import { create } from 'zustand';

export enum ApiPlatformValue {
  Ipe = 'ipe',
}

interface ConfigState {
  hasLoginSubjectSelector: boolean;
  hasAudienceScopeVisibleSelect: boolean;
  platformName?: string;
  apiPlatformValue?: ApiPlatformValue;
  isUniversity?: boolean;
}

const useConfigStore = create<ConfigState>()(() => ({
  hasLoginSubjectSelector: true,
  hasAudienceScopeVisibleSelect: false,
}));

export default useConfigStore;
